import { render, staticRenderFns } from "./DormantCampaignToLiveConfirmationModal.vue?vue&type=template&id=b313ba16"
import script from "./DormantCampaignToLiveConfirmationModal.vue?vue&type=script&lang=js"
export * from "./DormantCampaignToLiveConfirmationModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports